import React from 'react';
import { Button } from '@chakra-ui/react';

const SoldButton = () => {
  return (
    <Button variant="black" w="170px" py="22px" fontWeight="400" mb="30px" disabled={true}>
      SOLD
    </Button>
  );
};

export default SoldButton;
